module.exports = __webpack_public_path__ + "static/miss-anthropocene-aeb45b9895c096e9db0117f76be1c906.webp";